import { render, staticRenderFns } from "./AuditsView.vue?vue&type=template&id=55aba33f&scoped=true"
import script from "./AuditsView.vue?vue&type=script&lang=js"
export * from "./AuditsView.vue?vue&type=script&lang=js"
import style0 from "./AuditsView.vue?vue&type=style&index=0&id=55aba33f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aba33f",
  null
  
)

export default component.exports